export default __webpack_public_path__ + "static/media/logo.d5bd75f2.png";